import { render, staticRenderFns } from "./Wtfis.vue?vue&type=template&id=62396bcf&scoped=true&"
import script from "./Wtfis.vue?vue&type=script&lang=ts&"
export * from "./Wtfis.vue?vue&type=script&lang=ts&"
import style0 from "./Wtfis.vue?vue&type=style&index=0&id=62396bcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62396bcf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VIcon,VImg})
